module.exports = __webpack_public_path__ + "static/media/image-user-woman.d503f78c.svg";